import { gql } from "@apollo/client"

export const componentCtaCardID = "componentCtaCard"
export const componentCtaCardCollection = "componentCtaCardCollection"
export const GET_CTA_CARD_QUERY = gql`
    query getCtaCard($id: String!, $preview: Boolean = false) {
    ${componentCtaCardCollection}(where: {sys: {id: $id}}, preview: $preview) {
      items {
        theme
        heading
        copy
        secondCopy
        buttonLink
        buttonText
        image {
          title
          url
        }
        backgroundColor
        eyebrow
        buttonClassName
        subtext
        pebbleBackgroundColor
      }
    }
  }`

export const GET_CTA_CARDS_QUERY = gql`
  query getCtaCard($ids: [String!]!) {
    ${componentCtaCardCollection}(where: { sys: { id_in: $ids } }) {
      items {
        theme
        heading
        copy
        secondCopy
        buttonLink
        buttonText
        image {
          title
          url
        }
        backgroundColor
        eyebrow
        buttonClassName
        subtext
        pebbleBackgroundColor
      }
    }
  }
`
